(function () {
  'use strict';

  function stateStore() { return window.JPState || null; }

  function planMeta(id, scope) {
    var store = stateStore();
    if (store && typeof store.getPlan === 'function') return store.getPlan(id, scope);
    return { id: 'starter', name: 'STARTER', priceLabel: '', capacity: 0, available: false };
  }

  function validPlan(id, scope) {
    var store = stateStore();
    if (store && typeof store.isPlan === 'function') return store.isPlan(id, scope);
    return String(id || '') === 'starter';
  }

  function readPlan(scope) {
    var store = stateStore();
    var state = store && typeof store.read === 'function' ? store.read() : null;
    return state && validPlan(state.plan, scope) ? state.plan : 'starter';
  }

  function setPlan(id, reason) {
    var store = stateStore();
    if (!store || typeof store.setPlan !== 'function') return false;
    return store.setPlan(id, reason || 'plan-choice');
  }

  function usedSpaces() {
    var store = stateStore();
    var state = store && typeof store.read === 'function' ? store.read() : null;
    return (state && Array.isArray(state.items) ? state.items : []).reduce(function (sum, item) {
      if (!item || item.editorStatus === 'draft') return sum;
      var unit = Math.max(1, Number(item.spaces) || 1);
      var qty = Math.max(1, Math.floor(Number(item.quantity) || 1));
      return sum + unit * qty;
    }, 0);
  }

  function syncPackageSheet(sheet, currentId, requiredSpaces) {
    var required = Math.max(0, Number(requiredSpaces) || 0);
    var current = sheet.querySelector('[data-jp-package-plan="' + currentId + '"]');
    if (!current) current = sheet.querySelector('[data-jp-package-plan="starter"]');
    if (!current) return;

    sheet.querySelectorAll('[data-jp-package-plan]').forEach(function (button) {
      var id = button.dataset.jpPackagePlan;
      var meta = planMeta(id, sheet);
      var capacity = Math.max(0, Number(meta.capacity) || 0);
      var unavailable = meta.available === false || capacity < required;
      var active = button === current && !unavailable;
      button.disabled = unavailable;
      button.classList.toggle('is-unavailable', unavailable);
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-checked', String(active));
      var name = button.querySelector('.jp-home-plan-card__name');
      var status = button.querySelector('.jp-home-plan-card__status');
      var price = button.querySelector('.jp-home-plan-card__price');
      var spaces = button.querySelector('.jp-home-plan-card__spaces');
      if (name) name.textContent = meta.name || String(id || '').toUpperCase();
      if (status) status.textContent = active ? 'SELECTED' : unavailable && required ? Math.max(0, required - capacity) + ' SHORT' : 'SELECT';
      if (price) price.textContent = meta.priceLabel || '';
      if (spaces) spaces.textContent = capacity + ' SPACES';
    });

    var selectedButton = sheet.querySelector('[data-jp-package-plan].is-selected');
    var selected = planMeta(selectedButton ? selectedButton.dataset.jpPackagePlan : currentId, sheet);
    var selectedCapacity = sheet.querySelector('[data-jp-package-selected-capacity]');
    var selectedPrice = sheet.querySelector('[data-jp-package-selected-price]');
    if (selectedCapacity) selectedCapacity.textContent = selected.capacity;
    if (selectedPrice) selectedPrice.textContent = selected.priceLabel || '';
  }

  function syncPlanReadouts(scope) {
    var target = scope || document;
    var id = readPlan(target);
    var meta = planMeta(id, target);
    var exampleUsed = 6;
    var exampleRemaining = Math.max(0, Number(meta.capacity || 0) - exampleUsed);

    target.querySelectorAll('[data-jp-capacity-number]').forEach(function (node) { node.textContent = meta.capacity; });
    target.querySelectorAll('[data-jp-capacity-remaining]').forEach(function (node) { node.textContent = exampleRemaining; });
    target.querySelectorAll('[data-jp-capacity-progress]').forEach(function (node) {
      node.style.width = Math.min(100, meta.capacity ? exampleUsed / meta.capacity * 100 : 0) + '%';
    });
    target.querySelectorAll('[data-jp-photo-plan-capacity]').forEach(function (node) { node.textContent = meta.capacity; });
    target.querySelectorAll('[data-jp-photo-plan-price]').forEach(function (node) { node.textContent = meta.priceLabel || ''; });
    target.querySelectorAll('[data-jp-v4-spaces-rules-plan]').forEach(function (node) {
      node.textContent = meta.name + ' · ' + meta.priceLabel + ' · ' + meta.capacity + ' SPACES';
    });
    target.querySelectorAll('[data-jp-v4-spaces-rule-example]').forEach(function (node) {
      var spaces = Math.max(1, Number(node.dataset.jpV4SpacesRuleExample) || 1);
      var count = Math.floor(Number(meta.capacity || 0) / spaces);
      node.textContent = 'Up to ' + count + (count === 1 ? ' tattoo' : ' tattoos');
    });
    target.querySelectorAll('[data-jp-package-sheet]').forEach(function (sheet) { syncPackageSheet(sheet, id); });
  }

  function initPackageRoot(root) {
    if (!root || root.dataset.jpSetsReady === 'true') return;
    root.dataset.jpSetsReady = 'true';

    var sheet = root.querySelector('[data-jp-package-sheet]');
    if (!sheet) return;
    var panel = sheet.querySelector('.jp-home-sets-sheet__panel');
    var selectedPlan = readPlan(sheet);
    var opener = null;
    var closeTimer = 0;
    var returnContext = 'stay';
    var required = 0;

    function eligiblePlan(preferred) {
      var candidate = sheet.querySelector('[data-jp-package-plan="' + preferred + '"]');
      if (candidate) {
        var meta = planMeta(preferred, sheet);
        if (meta.available !== false && Number(meta.capacity || 0) >= required) return preferred;
      }
      var found = '';
      sheet.querySelectorAll('[data-jp-package-plan]').forEach(function (button) {
        if (found) return;
        var id = button.dataset.jpPackagePlan;
        var meta = planMeta(id, sheet);
        if (meta.available !== false && Number(meta.capacity || 0) >= required) found = id;
      });
      return found || preferred || 'starter';
    }

    function updateChoice(button) {
      if (!button || button.disabled) return;
      var nextPlan = button.dataset.jpPackagePlan;
      if (!validPlan(nextPlan, sheet)) return;
      var meta = planMeta(nextPlan, sheet);
      if (meta.available === false || Number(meta.capacity || 0) < required) return;
      selectedPlan = nextPlan;
      syncPackageSheet(sheet, selectedPlan, required);
    }

    function resetToStoredPlan() {
      selectedPlan = eligiblePlan(readPlan(sheet));
      syncPackageSheet(sheet, selectedPlan, required);
    }

    function open(button, detail) {
      window.clearTimeout(closeTimer);
      opener = button || document.activeElement;
      detail = detail || {};
      returnContext = String(detail.returnTo || button && button.dataset.jpPackageReturn || 'stay');
      required = Math.max(usedSpaces(), Number(detail.requiredSpaces) || 0);
      resetToStoredPlan();
      document.body.classList.add('jp-sets-sheet-open');
      sheet.hidden = false;
      sheet.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        sheet.classList.add('is-open');
        if (panel) panel.focus({ preventScroll: true });
      });
    }

    function finishClose() {
      sheet.hidden = true;
      sheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jp-sets-sheet-open');
      if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
      opener = null;
    }

    function close() {
      sheet.classList.remove('is-open');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(finishClose, 260);
    }

    root.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-jp-package-open]');
      if (openButton) { event.preventDefault(); open(openButton); return; }

      var closeButton = event.target.closest('[data-jp-package-close]');
      if (closeButton) { event.preventDefault(); close(); return; }

      var planButton = event.target.closest('[data-jp-package-plan]');
      if (planButton) { event.preventDefault(); updateChoice(planButton); return; }

      if (event.target.closest('[data-jp-package-confirm]')) {
        event.preventDefault();
        var selected = planMeta(selectedPlan, sheet);
        if (selected.available === false || Number(selected.capacity || 0) < required) return;
        if (!setPlan(selectedPlan, 'package-choice')) return;
        syncPlanReadouts(document);
        var detail = { plan: selectedPlan, capacity: Number(selected.capacity || 0), returnTo: returnContext, requiredSpaces: required };
        close();
        root.dispatchEvent(new CustomEvent('justpress:package-confirmed', { bubbles: true, detail: detail }));
      }
    });

    root.addEventListener('justpress:open-package-sheet', function (event) {
      open(event.target && event.target.closest ? event.target.closest('[data-jp-package-open]') : null, event.detail || {});
    });

    sheet.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    var params = new URLSearchParams(window.location.search);
    if (!params.get('mode') && params.get('panel') === 'package') {
      window.setTimeout(function () { open(null, { returnTo: 'stay' }); }, 0);
    }
  }

  function initSpacesSheets(scope) {
    var target = scope || document;
    target.querySelectorAll('[data-jp-v4-spaces-sheet]').forEach(function (sheet) {
      if (sheet.dataset.jpSpacesReady === 'true') return;
      sheet.dataset.jpSpacesReady = 'true';
      var panel = sheet.querySelector('.jp-v4-spaces-sheet__panel');
      var opener = null;
      var closeTimer = 0;

      function showView(name) {
        name = name === 'sizes' || name === 'rules' ? name : 'overview';
        sheet.dataset.jpV4SpacesViewState = name;
        sheet.querySelectorAll('[data-jp-v4-spaces-view]').forEach(function (view) {
          var active = view.dataset.jpV4SpacesView === name;
          view.hidden = !active;
          view.classList.toggle('is-active', active);
        });
        syncPlanReadouts(sheet);
        if (panel) panel.scrollTop = 0;
      }

      function open(button) {
        window.clearTimeout(closeTimer);
        opener = button || document.activeElement;
        showView('overview');
        sheet.hidden = false;
        sheet.setAttribute('aria-hidden', 'false');
        document.body.classList.add('jp-spaces-sheet-open');
        requestAnimationFrame(function () {
          sheet.classList.add('is-open');
          if (panel) panel.focus({ preventScroll: true });
        });
      }

      function finishClose() {
        sheet.hidden = true;
        sheet.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('jp-spaces-sheet-open');
        showView('overview');
        if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
        opener = null;
      }

      function close() {
        sheet.classList.remove('is-open');
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(finishClose, 220);
      }

      document.addEventListener('click', function (event) {
        var openButton = event.target.closest('[data-jp-v4-spaces-open]');
        if (openButton && openButton.closest('[data-jp-entry-scope]')) { event.preventDefault(); open(openButton); return; }

        var closeButton = event.target.closest('[data-jp-v4-spaces-close]');
        if (closeButton && closeButton.closest('[data-jp-v4-spaces-sheet]') === sheet) { event.preventDefault(); close(); return; }

        var viewButton = event.target.closest('[data-jp-v4-spaces-view-open]');
        if (viewButton && viewButton.closest('[data-jp-v4-spaces-sheet]') === sheet) {
          event.preventDefault();
          showView(viewButton.dataset.jpV4SpacesViewOpen);
          return;
        }

        var backButton = event.target.closest('[data-jp-v4-spaces-back]');
        if (backButton && backButton.closest('[data-jp-v4-spaces-sheet]') === sheet) {
          event.preventDefault();
          showView('overview');
        }
      });

      sheet.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (sheet.dataset.jpV4SpacesViewState && sheet.dataset.jpV4SpacesViewState !== 'overview') showView('overview');
        else close();
      });
    });
  }

  function init(scope) {
    var target = scope || document;
    target.querySelectorAll('[data-jp-package-root]').forEach(initPackageRoot);
    initSpacesSheets(target);
    syncPlanReadouts(target);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
  document.addEventListener('justpress:state-change', function () { syncPlanReadouts(document); });
  window.addEventListener('storage', function () { syncPlanReadouts(document); });
})();
